module.exports = __webpack_public_path__ + "img/icon-close.383d1284.svg";